var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-input-container"},[(_vm.isEdit)?_c('input',{ref:"inp",staticClass:"mx-input",attrs:{"placeholder":"输入价格"},domProps:{"value":_vm.value},on:{"blur":_vm.changeValue}}):_c('div',{staticClass:"mx-input",on:{"click":_vm.handleClick}},[_vm._t("default"),_vm._v("ms")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }